import { baseURL } from "../httpService";
import { getAccessToken, setAccessToken } from "./tokenStore";

export const refreshToken = localStorage.getItem("refreshToken");

export async function getMyProfile() {
  try {
    let accessToken = getAccessToken(); // from memory

    // 🔹 If no access token in memory, try refresh immediately
    if (!accessToken && refreshToken) {
      const refreshResponse = await fetch(`${baseURL}/refresh`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${refreshToken}`,
        },
      });

      if (!refreshResponse.ok) {
        localStorage.removeItem("refreshToken");
        return null; // user must login again
      }

      const refreshData = await refreshResponse.json();
      accessToken = refreshData.accessToken;
      setAccessToken(accessToken); // store in memory
    }

    // 🔹 If still no access token → not authenticated
    if (!accessToken) return null;

    // 🔹 Call protected route
    const response = await fetch(`${baseURL}/myprofile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    // 🔹 If access token expired → try refresh again
    if (response.status === 401 && refreshToken) {
      const refreshResponse = await fetch(`${baseURL}/refresh`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${refreshToken}`,
        },
      });

      if (!refreshResponse.ok) {
        localStorage.removeItem("refreshToken");
        return null;
      }

      const refreshData = await refreshResponse.json();
      accessToken = refreshData.accessToken;
      setAccessToken(accessToken);

      // retry request with new token
      const retryResponse = await fetch(`${baseURL}/myprofile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!retryResponse.ok) return null;
      return await retryResponse.json();
    }

    if (!response.ok) return null;

    return await response.json();
  } catch (err) {
    console.error("getMyProfile error:", err);
    return null;
  }
}
